import React from 'react';
import './style.css';

// Helper function to map card string to image path
const getCardImage = (cardCode) => {
    if (!cardCode) return null;

    try {
        if (cardCode.length < 3) {
            return null;
        }

        // Use cloudfront URL or fallback to local assets
        // Format: rank + suit (DD, SS, CC, HH)
        return `https://d3kb8xz339pq18.cloudfront.net/v12/static/backend/images/cards/${cardCode}.png`;
    } catch (e) {
        return null;
    }
};

// Helper function to parse card string and get array of card images
const parseCards = (cardString) => {
    if (!cardString) return [];

    const cards = cardString.split(',').map(card => card.trim());
    return cards.map(card => getCardImage(card)).filter(card => card !== null);
};

// Helper function to parse rdesc string
// Format: "No (13)#Big  Small  Small  Small  Small#No  Yes  No  Yes  No#Yes"
const parseRdesc = (rdesc) => {
    if (!rdesc) return {
        raceTo17: "",
        bigCard: [],
        zeroCard: [],
        oneZeroCard: ""
    };

    const parts = rdesc.split('#').map(part => part.trim());

    return {
        raceTo17: parts[0] || "", // "No (13)"
        bigCard: parts[1] ? parts[1].split(/\s+/).filter(s => s.length > 0) : [], // ["Big", "Small", "Small", "Small", "Small"]
        zeroCard: parts[2] ? parts[2].split(/\s+/).filter(s => s.length > 0) : [], // ["No", "Yes", "No", "Yes", "No"]
        oneZeroCard: parts[3] || "" // "Yes"
    };
};

const Race17 = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
    // Parse cards from detailResult
    const cards = detailResult?.card ? parseCards(detailResult.card) : [];
    const rdescData = detailResult?.rdesc ? parseRdesc(detailResult.rdesc) : {};

    return (
        <div>
            <div className="row">
                <div className="col-12">
                    <h6 className="text-right">
                        <b>Round Id :</b> {roundId}
                    </h6>
                    <div className="text-center luckyseven-img">
                        <div className="row">
                            {cards.map((card, index) => (
                                card && (
                                    <div key={index} className="col">
                                        <img
                                            src={card}
                                            alt={`Card ${index + 1}`}
                                            onError={(e) => {
                                                // Fallback to local assets
                                                const cardName = card.split('/').pop();
                                                const fallbackPath = `/assets/img/card-results/${cardName}`;
                                                if (e.target.src !== fallbackPath) {
                                                    e.target.src = fallbackPath;
                                                } else {
                                                    e.target.style.display = 'none';
                                                }
                                            }}
                                        />
                                    </div>
                                )
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <p className="text-left mt-3">
                {rdescData.raceTo17 && (
                    <>
                        <b className="text-success">Race to 17: </b>
                        {rdescData.raceTo17}
                        <br />
                    </>
                )}
                {rdescData.bigCard.length > 0 && (
                    <>
                        <b className="text-success">Big Card: </b>
                        {rdescData.bigCard.join('  ')}
                        <br />
                    </>
                )}
                {rdescData.zeroCard.length > 0 && (
                    <>
                        <b className="text-success">Zero Card: </b>
                        {rdescData.zeroCard.join('  ')}
                        <br />
                    </>
                )}
                {rdescData.oneZeroCard && (
                    <>
                        <b className="text-success">One Zero Card: </b>
                        {rdescData.oneZeroCard}
                        <br />
                    </>
                )}
            </p>
        </div>
    );
};

export default Race17;
